import { Box, Button, Flex, HStack, Image, Separator, Stack, Text } from "@chakra-ui/react"
import { Form, UI } from "components"
import { API } from "config"
import { toaster } from "config"
import { useState } from "react"
import { useNavigate } from "react-router"

export default function Init(){

    const navigate = useNavigate()
    const [ email, setEmail ] = useState()
    const [ loading, setLoading ] = useState()
    const [ success, setSuccess ] = useState(false)

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.post('/recovery', { email })
            toaster.create({ title: 'O link de redefinição de senha foi enviado para seu e-mail.' })
            setSuccess(true)
        }catch(err){
            toaster.create({ title: 'Não foi possível continuar. Tente novamente!', description: err?.response?.data?.message, type: 'warning' })
            setLoading(false)
        }
    }

    return(
    <Flex h="100vh" overflow="hidden">

        {/* ── Painel esquerdo: Identidade da marca ── */}
        <Flex
            hideBelow="lg"
            flex="1"
            direction="column"
            align="center"
            justify="center"
            position="relative"
            overflow="hidden"
            style={{ background: 'linear-gradient(160deg, #0f172a 0%, #1e2d4d 60%, #0f172a 100%)' }}
            p={12}
            gap={10}
        >
            <Box position="absolute" top="-80px" right="-80px" w="360px" h="360px" borderRadius="full" style={{ background: 'rgba(251,146,60,0.07)' }} />
            <Box position="absolute" bottom="-120px" left="-60px" w="440px" h="440px" borderRadius="full" style={{ background: 'rgba(251,146,60,0.05)' }} />
            <Box position="absolute" top="42%" left="-50px" w="220px" h="220px" borderRadius="full" style={{ background: 'rgba(251,146,60,0.04)' }} />

            <Stack align="center" gap={5} zIndex={1} w="100%" maxW="320px">
                <HStack gap={4}>
                    <Image src="/icon.png" h="64px" />
                    <Box>
                        <Text color="white" fontWeight="bold" fontSize="3xl" lineHeight="1">Bonífica</Text>
                        <Text color="orange.300" fontSize="sm" mt={1}>Escritório de Núcleos</Text>
                    </Box>
                </HStack>

                <Box h="1px" bg="rgba(255,255,255,0.12)" w="100%" />

                <Box textAlign="center">
                    <Text color="white" fontSize="xl" fontWeight="semibold" lineHeight="1.5">
                        Recuperação<br />de acesso
                    </Text>
                    <Text mt={3} fontSize="sm" style={{ color: 'rgba(255,255,255,0.55)' }} lineHeight="1.6">
                        Informe seu e-mail cadastrado e enviaremos<br />um link para redefinir sua senha.
                    </Text>
                </Box>
            </Stack>

            <Stack gap={4} zIndex={1} w="100%" maxW="300px">
                {[
                    { icon: 'mail', text: 'Link enviado para seu e-mail' },
                    { icon: 'key', text: 'Redefinição segura de senha' },
                    { icon: 'check', text: 'Acesso restaurado em minutos' },
                ].map(({ icon, text }) => (
                    <HStack key={text} gap={3}>
                        <Box p={2} borderRadius={6} style={{ background: 'rgba(251,146,60,0.15)' }} flexShrink={0}>
                            <UI.Icon name={icon} color="orange.300" boxSize={4} />
                        </Box>
                        <Text fontSize="sm" style={{ color: 'rgba(255,255,255,0.75)' }}>{text}</Text>
                    </HStack>
                ))}
            </Stack>
        </Flex>

        {/* ── Painel direito: Formulário ── */}
        <Flex
            flex={{ base: 1, lg: '0 0 460px' }}
            direction="column"
            align="center"
            justify="center"
            p={8}
            bg="bg"
        >
            <Stack gap={6} w="100%" maxW="380px">

                <HStack hideFrom="lg" gap={3} justify="center">
                    <Image src="/icon.png" h="36px" />
                    <Box>
                        <Text fontWeight="bold" fontSize="lg">Bonífica</Text>
                        <Text fontSize="xs" color="fg.muted">Escritório de Núcleos</Text>
                    </Box>
                </HStack>

                <UI.Show visible={success}>
                    <Stack gap={4} align="center" textAlign="center">
                        <UI.Lottie animation="mail" style={{ width: '160px' }} />
                        <Box>
                            <Text fontSize="2xl" fontWeight="bold">Verifique seu e-mail</Text>
                            <Text fontSize="sm" color="fg.muted" mt={2} lineHeight="1.6">
                                Uma mensagem foi enviada para <b>{email}</b>. Abra a mensagem e clique no link para redefinir sua senha.
                            </Text>
                        </Box>
                        <Button w="100%" variant="outline" colorPalette="orange" onClick={() => navigate('/')}>
                            <UI.Icon name="prev" /> Voltar para o login
                        </Button>
                    </Stack>
                </UI.Show>

                <UI.Show visible={!success}>
                    <Box>
                        <Text fontSize="2xl" fontWeight="bold">Esqueceu a senha?</Text>
                        <Text color="fg.muted" fontSize="sm" mt={1}>Informe seu e-mail para receber o link de redefinição</Text>
                    </Box>

                    <Form.Container onSubmit={handleSubmit}>
                        <Form.Text
                            required
                            autoFocus
                            type="email"
                            label="Endereço de e-mail"
                            placeholder="maria@bonificaoficial.com"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            disabled={loading}
                            helper="O e-mail que você utiliza para acessar o escritório."
                        />
                        <Button
                            type="submit"
                            w="100%"
                            size="lg"
                            colorPalette="orange"
                            loading={loading}
                            loadingText="Verificando..."
                        >
                            <UI.Icon name="mail" /> Enviar link de redefinição
                        </Button>
                    </Form.Container>

                    <HStack gap={3}>
                        <Separator flex="1" />
                        <Text fontSize="xs" color="fg.subtle">ou</Text>
                        <Separator flex="1" />
                    </HStack>

                    <Button w="100%" variant="ghost" onClick={() => navigate('/')}>
                        <UI.Icon name="prev" /> Voltar para o login
                    </Button>
                </UI.Show>

            </Stack>
        </Flex>

    </Flex>
    )
}
